import { useState, useRef } from 'react'
import {
  makeStyles,
  Grid,
  Container,
  Link as MuiLink,
  TextField,
  useTheme,
  useMediaQuery,
  Snackbar,
} from '@material-ui/core'
import { useRouter } from 'next/router'
import WidgetNew from '../components/pages-new/WidgetNew'
import Layout from '../components/common/Layout'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import clsx from 'clsx'
import ModalSp from '../components/ui/ModalSp'
import ButtonSp from '../components/ui/ButtonSp'
import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
  },
  page: {
    width: '100vw',
    flexGrow: 1,
    padding: '20px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  title: {
    ...theme.homeStyle.title,
  },
  subtitle: {
    ...theme.homeStyle.subtitle,
  },
  titleWithSubtitle: {
    marginBottom: 0,
  },
  topic: {
    ...theme.homeStyle.topic,
    marginBottom: 0,
    marginTop: 0,
  },
  widgetsGridContainer: {
    textAlign: 'left',
  },
  widgetsGridItem: {
    '& > h4': {
      width: '100%',
    },
    '& > p': {
      width: '100%',
      marginTop: 0,
    },
    '& > img': {
      maxWidth: '100%',
    },
  },
  bodyText: {
    color: '#828282',
  },
  button: {
    ...theme.homeStyle.button,
    alignSelf: 'flex-start',
  },
}))

const WidgetsGridItem = ({ children }) => {
  const classes = useStyles()
  return (
    <Grid
      item
      xs={12}
      sm={6}
      container
      direction="column"
      alignItems="center"
      className={classes.widgetsGridItem}
    >
      {children}
    </Grid>
  )
}

const CopiedSnackBar = ({ open, setOpen, text }) => {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={open}
      autoHideDuration={1000}
      onClose={() => setOpen(false)}
      message={text}
    />
  )
}

const CopyField = ({ text, copiedText }) => {
  const [copied, setCopied] = useState(false)
  const copyFieldRef = useRef(null)
  const copyToClipboard = (e) => {
    if (typeof window !== 'undefined') {
      copyFieldRef.current.select()
      document.execCommand('copy')
      e.target.focus()
      setCopied(true)
    }
  }
  const { t } = useTranslation('widget')

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <TextField
          variant="outlined"
          fullWidth
          value={text}
          inputRef={copyFieldRef}
          readOnly
          multiline
        />
        <div style={{ height: 8 }} />
        <ButtonSp onClick={copyToClipboard}>{t('copy-button')}</ButtonSp>
      </div>
      <CopiedSnackBar open={copied} setOpen={setCopied} text={copiedText} />
    </>
  )
}

const WidgetPageOld = () => {
  const classes = useStyles()
  const { t } = useTranslation('widget')
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const [modalOpen, setModalOpen] = useState([
    false,
    false,
    false,
    false,
    false,
  ])

  const setModalOpenByIndex = (index, value) => {
    let newState = [...modalOpen]
    newState[index] = value
    setModalOpen(newState)
  }

  const renderModal = (index, title, code = '', widget = <h1>No</h1>) => {
    return (
      <ModalSp
        open={modalOpen[index]}
        onClose={() => setModalOpenByIndex(index, false)}
        title={title}
        fullScreen={isMobile}
        maxWidth="lg"
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <p>{t('copy-instruction')}</p>
            <CopyField text={code} copiedText={t('copied')} />
          </Grid>
          <Grid item xs={12} sm={6}>
            {widget}
          </Grid>
        </Grid>
      </ModalSp>
    )
  }

  return (
    <div className={classes.root}>
      <Layout
        title="Widgets เครื่องมือช่วยเหลือลูกค้า สำหรับร้านค้าของคุณ - SHIPPOP"
        keywords="ติดตามเลขพัสดุ, น้ำหนักพัสดุ, เช็คเลขแทร็ค, รับส่งพัสดุ"
        description="เครื่องมือช่วยเหลืออำนวยความสะดวกให้กับร้านค้าของคุณกับ SHIPPOP Widgets ติดตามสถานะพัสดุ คำนวณน้ำหนักของพัสดุ  คำนวณราคาค่าขนส่ง ค้นหาจุดไปรษณีย์ไทย Drop-off"
      >
        <div className={classes.page}>
          <Container maxWidth="md">
            <h1 className={clsx(classes.title, classes.titleWithSubtitle)}>
              Widgets
            </h1>
            <h2 className={classes.subtitle}>{t('page-subtitle')}</h2>
            <Grid
              container
              spacing={4}
              className={classes.widgetsGridContainer}
            >
              <WidgetsGridItem>
                <img
                  src="/static/img/widget/embed_01.png"
                  alt="SHIPPOP Tracking Info"
                />
              </WidgetsGridItem>
              <WidgetsGridItem>
                <h4 className={classes.topic}>{t('tracking-info.title')}</h4>
                <p className={classes.bodyText}>
                  {t('tracking-info.subtitle')}
                  <br />
                  <br />
                  {t('tracking-info.desc')}&nbsp;&nbsp;
                  <MuiLink
                    href="https://www.shippop.com/embed/tracking-info/?tracking_code=SP000001735"
                    target="_blank"
                    style={{ wordBreak: 'break-word' }}
                  >
                    {t('click-for-example')}
                  </MuiLink>
                </p>
                <ButtonSp
                  className={classes.button}
                  onClick={() => setModalOpenByIndex(0, true)}
                >
                  {t('get-code')}
                </ButtonSp>
              </WidgetsGridItem>
              <WidgetsGridItem>
                <img
                  src="/static/img/widget/embed_01.png"
                  alt="SHIPPOP Tracking"
                />
              </WidgetsGridItem>
              <WidgetsGridItem>
                <h4 className={classes.topic}>{t('tracking.title')}</h4>
                <p className={classes.bodyText}>
                  {t('tracking.subtitle')}
                  <br />
                  <br />
                  {t('tracking.desc')}
                </p>
                <ButtonSp
                  className={classes.button}
                  onClick={() => setModalOpenByIndex(1, true)}
                >
                  {t('get-code')}
                </ButtonSp>
              </WidgetsGridItem>
              <WidgetsGridItem>
                <img
                  src="/static/img/widget/embed_02.png"
                  alt="SHIPPOP Calculator"
                />
              </WidgetsGridItem>
              <WidgetsGridItem>
                <h4 className={classes.topic}>{t('calculator.title')}</h4>
                <p className={classes.bodyText}>
                  {t('calculator.subtitle')}
                  <br />
                  <br />
                  {t('calculator.desc')}
                </p>
                <ButtonSp
                  className={classes.button}
                  onClick={() => setModalOpenByIndex(2, true)}
                >
                  {t('get-code')}
                </ButtonSp>
              </WidgetsGridItem>
              <WidgetsGridItem>
                <img
                  src="/static/img/widget/embed_03.png"
                  alt="SHIPPOP Rate Checker"
                />
              </WidgetsGridItem>
              <WidgetsGridItem>
                <h4 className={classes.topic}>{t('rate-checker.title')}</h4>
                <p className={classes.bodyText}>
                  {t('rate-checker.subtitle')}
                  <br />
                  <br />
                  {t('rate-checker.desc')}
                </p>
                <ButtonSp
                  className={classes.button}
                  onClick={() => setModalOpenByIndex(3, true)}
                >
                  {t('get-code')}
                </ButtonSp>
              </WidgetsGridItem>
              <WidgetsGridItem>
                <img
                  src="/static/img/widget/embed_04.png"
                  alt="SHIPPOP Dropoff"
                />
              </WidgetsGridItem>
              <WidgetsGridItem>
                <h4 className={classes.topic}>{t('drop-off.title')}</h4>
                <p className={classes.bodyText}>
                  {t('drop-off.subtitle')}
                  <br />
                  <br />
                  {t('drop-off.desc')}
                </p>
                <ButtonSp
                  className={classes.button}
                  onClick={() => setModalOpenByIndex(4, true)}
                >
                  {t('get-code')}
                </ButtonSp>
              </WidgetsGridItem>
            </Grid>
          </Container>
        </div>
        {renderModal(
          0,
          'SHIPPOP Tracking Info',
          `<iframe src="${publicRuntimeConfig.siteDomain}/embed/tracking-info" width="320" height="350" frameBorder="0" scrolling="auto"></iframe>`,
          <iframe
            src={`${publicRuntimeConfig.siteDomain}/embed/tracking-info`}
            width="320"
            height="350"
            frameBorder="0"
            scrolling="auto"
          ></iframe>
        )}
        {renderModal(
          1,
          'SHIPPOP Tracking',
          `<iframe src="${publicRuntimeConfig.siteDomain}/embed/tracking" width="320" height="200" frameBorder="0" scrolling="auto"></iframe>`,
          <iframe
            src={`${publicRuntimeConfig.siteDomain}/embed/tracking`}
            width="320"
            height="200"
            frameBorder="0"
            scrolling="auto"
          ></iframe>
        )}
        {renderModal(
          2,
          'SHIPPOP Calculator',
          `<iframe src="${publicRuntimeConfig.siteDomain}/embed/weight" width="320" height="320" frameBorder="0" scrolling="auto"></iframe>`,
          <iframe
            src={`${publicRuntimeConfig.siteDomain}/embed/weight`}
            width="320"
            height="320"
            frameBorder="0"
            scrolling="auto"
          ></iframe>
        )}
        {renderModal(
          3,
          'SHIPPOP Rate Checker',
          `<iframe src="${publicRuntimeConfig.siteDomain}/embed/checkprice" width="320" height="320" frameBorder="0" scrolling="auto"></iframe>`,
          <iframe
            src={`${publicRuntimeConfig.siteDomain}/embed/checkprice`}
            width="320"
            height="320"
            frameBorder="0"
            scrolling="auto"
          ></iframe>
        )}
        {renderModal(
          4,
          'SHIPPOP Dropoff',
          `<iframe src="${publicRuntimeConfig.siteDomain}/embed/nearby-dropoff" width="320" height="540" frameBorder="0" scrolling="auto" allow="geolocation"></iframe>`,
          <iframe
            src={`${publicRuntimeConfig.siteDomain}/embed/nearby-dropoff`}
            width="320"
            height="540"
            frameBorder="0"
            scrolling="auto"
            allow="geolocation"
          ></iframe>
        )}
      </Layout>
    </div>
  )
}

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      'common',
      'header',
      'footer',
      'pdpa',
      'widget',
    ])),
  },
})

// ?new → new-design variant (new chrome, same content); otherwise the old
// page renders unchanged. Wrapper keeps hook order stable across both paths
// (each branch is its own component, so neither shares the other's hooks).
const WidgetPage = (props) => {
  const { query } = useRouter()
  if ('old' in query) return <WidgetPageOld {...props} />
  return <WidgetNew {...props} />
}

export default WidgetPage
